import { useTranslation } from 'react-i18next';

import { routeToConnectionsPage } from 'support/helpers/navigation/navigation';
import { RelationshipState } from 'support/types/dtos';

import { DashboardCard } from '../components/DashboardCard/DashboardCard';
import { DashboardSection } from '../components/DashboardSection';

type ConnectionsStatsDisplayProps = {
  numberOfReadyConnections: number;
};

export function ConnectionsStatsDisplay({ numberOfReadyConnections }: ConnectionsStatsDisplayProps) {
  const { t } = useTranslation();

  return (
    <DashboardSection title={t('dashboard:connections.title')}>
      <div className="grid grid-cols-1">
        <DashboardCard
          to={routeToConnectionsPage({ state: RelationshipState.READY })}
          title={t('dashboard:connections.ready')}
          value={numberOfReadyConnections}
          testId="ready-connections"
        />
      </div>
    </DashboardSection>
  );
}
